import { render } from "./emailtype.vue?vue&type=template&id=6968073a&scoped=true"
import script from "./emailtype.vue?vue&type=script&lang=js"
export * from "./emailtype.vue?vue&type=script&lang=js"

import "./emailtype.vue?vue&type=style&index=0&id=6968073a&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6968073a"]])

export default __exports__